import { FC } from 'react';
import { IotListProps } from './types';
import { StyledList } from './styles';
import { IotListItem } from '../IotListItem/IotListItem';

const defaultSettings = {
  columns: 1,
  lineClamp: 1,
  iconSize: 24,
  iconBorderRadius: 999,
  compact: false,
  itemContentSpacing: 8,
};

export const IotList: FC<IotListProps & { children?: any }> = ({
  items,
  settings = defaultSettings,
}) => {
  const listSettings = { ...defaultSettings, ...settings };
  return (
    <StyledList columns={listSettings.columns}>
      {items.map((item, index) => (
        <IotListItem item={item} key={index} settings={listSettings} compact={settings.compact} />
      ))}
    </StyledList>
  );
};
